import { Injectable } from '@angular/core';
import { AbstractControl, FormBuilder } from '@angular/forms';
import { FormTemplateInterface } from '@rx-applications/shared/utils-forms';
import { Room } from '@rx-applications/clientsite/shared/utils';

@Injectable({ providedIn: 'root' })
export class RoomFormTemplateService implements FormTemplateInterface<Room> {
  constructor(private formBuilder: FormBuilder) {}

  getTemplate(defaultValue?: Room): AbstractControl {
    return this.formBuilder.group({
      reference: [defaultValue?.reference],
      guests: this.formBuilder.array([]),
    });
  }
}
